import { ProductsListComponent } from "./pages/products/products-list/products-list.component";
import { AuthGuard } from "../../auth/helpers";
import { ProductsDetailComponent } from "./pages/products/products-detail/products-detail.component";
import { ProductDealsCreateComponent } from "./pages/deals/product-deals-create/product-deals-create.component";
import { ProductDealsEditComponent } from "./pages/deals/product-deals-edit/product-deals-edit.component";
import { ProductCommissionCreateComponent } from "./pages/commission/product-commission-create/product-commission-create.component";
import { ProductCommissionEditComponent } from "./pages/commission/product-commission-edit/product-commission-edit.component";
import { ProductsCostListComponent } from "./pages/products-cost-list/products-cost-list.component";
import { IRoute } from "app/auth/models/utils-interfaces";
import { ProductDealsDuplicateComponent } from "./pages/deals/product-deals-duplicate/product-deals-duplicate.component";

const productsRoutes: IRoute[] = [
  {
    path: "dashboard/products/list",
    component: ProductsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/product/:id",
    component: ProductsDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/deals/create-product-deal",
    component: ProductDealsCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/deals/edit-product-deal/:id",
    component: ProductDealsEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/deals/duplicate-product-deal/:id",
    component: ProductDealsDuplicateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/commissions/create-product-commission",
    component: ProductCommissionCreateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/commissions/edit-product-commission/:id",
    component: ProductCommissionEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/products/costs-list",
    component: ProductsCostListComponent,
    canActivate: [AuthGuard],
  },
];
export default productsRoutes;
